jQuery( function ( $ ) {

  function resize () {
    $( 'section.text_blocks.default-blocks' ).each( function () {
      const $row = $( '.main-row', this );
      const $blocks = $( '.text-block', this );
      $( 'h3', $blocks ).height( 'auto' );
      const per_chunk = Math.round( $row.width() / $blocks.outerWidth() );
      if ( per_chunk > 1 ) {
        const chunks = $blocks.toArray().reduce( ( chunks, one, i ) => {
          const ch = Math.floor( i / per_chunk );
          chunks[ ch ] = ( chunks[ ch ] || [] ).concat( one ); 
          return chunks;
        }, []);
        chunks.forEach( chunk => {
          const $headings = $( 'h3', $( chunk ) );
          const max = Math.max( ...$headings.toArray().map( el => $(el).height() ) );
          $headings.height( max );
        });
      }
    });
  }

  resize();
  $( window ).on( 'breakpoint_changed', resize );

})